import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class sets so a caller's class wins over a component's default instead of both
 * landing in the DOM and the later one winning by accident.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
